import { useTextePublic } from '../lib/textes-publics'
/**
 * Garde de l’espace `/portail` : session abonné obligatoire (POR-01).
 *
 * Un membre du personnel connecté n’est pas un abonné : il est renvoyé vers
 * l’écran de connexion du portail, sans message ambigu.
 */

import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router'

import { CHEMINS, urlConnexion } from '../lib/chemins'
import { ChargementPage } from '../ui/Spinner'
import { useAuth } from './useAuth'

export interface RequireAbonneProps {
  readonly children?: ReactNode | undefined
}

export function RequireAbonne({ children }: RequireAbonneProps) {
  const texteInterface = useTextePublic()
  const { session, chargement } = useAuth()
  const emplacement = useLocation()

  if (chargement) return <ChargementPage libelle={texteInterface('Vérification de la session…')} />

  if (session === null || session.sujet !== 'abonne') {
    const destination = `${emplacement.pathname}${emplacement.search}`
    return <Navigate to={urlConnexion(CHEMINS.connexionAbonne, destination)} replace />
  }

  return <>{children ?? <Outlet />}</>
}
